import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Headline from '../../ui/Headline';
import { setIsModalOpen, setModalContent } from '../../store/slices/global';
import { MODAL_CONTENT } from '../../app.config.vars/modalContent';
import { useNavigate, useParams } from 'react-router-dom';
import { APP_ROUTES } from '../../app.config.vars/routes';
import { generateEditorRoutePath, generateIdRoutePath } from '../../helpers';
import { getEditors, getEditorsPerInstitution } from '../../api/admin/editors';
import SuperAdminUnitCard from '../../ui/SuperAdminUnitCard';
import { useSelector } from 'react-redux';
import { selectEditors, selectEditorsCurrentPage, setEditors, setEditorsCurrentPage, } from '../../store/adminSlices/editors';
import Loader from '../../ui/Loader';
import Pagination from '../../components/Pagination';
import { EDITORS_LIST_PER_PAGE_ITEMS } from '../../app.config.vars/stored';
import { useAppDispatch } from '../../store';
const EditorsList = ({ role }) => {
    const { id } = useParams();
    const { t } = useTranslation();
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const editors = useSelector(selectEditors);
    const currentPage = useSelector(selectEditorsCurrentPage);
    const [totalPages, setTotalPages] = useState(1);
    const [submitStatus, setSubmitStatus] = useState(null);
    const [editorInteractionStatus, setEditorInteractionStatus] = useState(null);
    const fetchEditors = async () => {
        try {
            let editors;
            if (role === 'super_admin') {
                editors = await getEditorsPerInstitution(id, currentPage);
            }
            else {
                editors = await getEditors(currentPage);
            }
            dispatch(setEditors(editors.data));
            setTotalPages(Math.ceil(editors.pagination.totalItems / EDITORS_LIST_PER_PAGE_ITEMS));
        }
        catch (err) {
            dispatch(setIsModalOpen(true));
            dispatch(setModalContent(MODAL_CONTENT.somethingWentWrong.key));
        }
    };
    const updateEditors = async () => {
        setSubmitStatus('pending');
        await fetchEditors();
        setSubmitStatus(null);
    };
    useEffect(() => {
        if (id) {
            dispatch(setEditorsCurrentPage(1));
            updateEditors();
        }
    }, [id]);
    useEffect(() => {
        updateEditors();
    }, [currentPage]);
    useEffect(() => {
        return () => {
            dispatch(setEditors(null));
            dispatch(setEditorsCurrentPage(1));
        };
    }, []);
    const onEditEditor = (editorId) => {
        if (role === 'super_admin') {
            navigate(generateEditorRoutePath(APP_ROUTES.superAdminEditEditor, id, editorId));
        }
        else {
            navigate(generateIdRoutePath(APP_ROUTES.editEditor, String(editorId)));
        }
    };
    return (_jsxs("div", { className: 'super-admin-units', children: [editors && editors.length > 0 && _jsx(Headline, { title: t('admin.your_editors'), type: 'h1' }), submitStatus !== 'pending' && editors ? (_jsxs(_Fragment, { children: [_jsx("div", { className: "editors-list", children: editors.map((editor) => (_jsx(SuperAdminUnitCard, { unitId: editor.id, unit: 'editor', email: editor.email, name: `${editor.firstName} ${editor.lastName}`, isActive: editor.isActive, onUnitEdit: () => onEditEditor(editor.id), submitStatus: editorInteractionStatus, setSubmitStatus: setEditorInteractionStatus, institutionId: id }, editor.id))) }), totalPages > 1 && (_jsx(Pagination, { currentPage: currentPage, totalPages: totalPages, onPageChange: (newPage) => dispatch(setEditorsCurrentPage(newPage)) }))] })) : (_jsx(Loader, {}))] }));
};
export default EditorsList;
